var map = {
	"./bowls/bowl-1/metadata.json": 29,
	"./bowls/bowl-10/metadata.json": 30,
	"./bowls/bowl-11/metadata.json": 31,
	"./bowls/bowl-12/metadata.json": 32,
	"./bowls/bowl-13/metadata.json": 33,
	"./bowls/bowl-14/metadata.json": 34,
	"./bowls/bowl-15/metadata.json": 35,
	"./bowls/bowl-16/metadata.json": 36,
	"./bowls/bowl-17/metadata.json": 37,
	"./bowls/bowl-18/metadata.json": 38,
	"./bowls/bowl-19/metadata.json": 39,
	"./bowls/bowl-2/metadata.json": 40,
	"./bowls/bowl-20/metadata.json": 41,
	"./bowls/bowl-21/metadata.json": 42,
	"./bowls/bowl-22/metadata.json": 43,
	"./bowls/bowl-23/metadata.json": 44,
	"./bowls/bowl-24/metadata.json": 45,
	"./bowls/bowl-25/metadata.json": 46,
	"./bowls/bowl-26/metadata.json": 47,
	"./bowls/bowl-27/metadata.json": 48,
	"./bowls/bowl-28/metadata.json": 49,
	"./bowls/bowl-29/metadata.json": 50,
	"./bowls/bowl-3/metadata.json": 51,
	"./bowls/bowl-30/metadata.json": 52,
	"./bowls/bowl-31/metadata.json": 53,
	"./bowls/bowl-32/metadata.json": 54,
	"./bowls/bowl-4/metadata.json": 55,
	"./bowls/bowl-5/metadata.json": 56,
	"./bowls/bowl-6/metadata.json": 57,
	"./bowls/bowl-7/metadata.json": 58,
	"./bowls/bowl-8/metadata.json": 59,
	"./bowls/bowl-9/metadata.json": 60,
	"./cups/cup-1/metadata.json": 61,
	"./cups/cup-2/metadata.json": 62,
	"./cups/cup-3/metadata.json": 63,
	"./mugs/mug-1/metadata.json": 64,
	"./mugs/mug-10/metadata.json": 65,
	"./mugs/mug-11/metadata.json": 66,
	"./mugs/mug-12/metadata.json": 67,
	"./mugs/mug-13/metadata.json": 68,
	"./mugs/mug-14/metadata.json": 69,
	"./mugs/mug-15/metadata.json": 70,
	"./mugs/mug-16/metadata.json": 71,
	"./mugs/mug-17/metadata.json": 72,
	"./mugs/mug-18/metadata.json": 73,
	"./mugs/mug-19/metadata.json": 74,
	"./mugs/mug-2/metadata.json": 75,
	"./mugs/mug-20/metadata.json": 76,
	"./mugs/mug-21/metadata.json": 77,
	"./mugs/mug-22/metadata.json": 78,
	"./mugs/mug-23/metadata.json": 79,
	"./mugs/mug-24/metadata.json": 80,
	"./mugs/mug-25/metadata.json": 81,
	"./mugs/mug-26/metadata.json": 82,
	"./mugs/mug-27/metadata.json": 83,
	"./mugs/mug-28/metadata.json": 84,
	"./mugs/mug-29/metadata.json": 85,
	"./mugs/mug-3/metadata.json": 86,
	"./mugs/mug-30/metadata.json": 87,
	"./mugs/mug-31/metadata.json": 88,
	"./mugs/mug-32/metadata.json": 89,
	"./mugs/mug-4/metadata.json": 90,
	"./mugs/mug-5/metadata.json": 91,
	"./mugs/mug-6/metadata.json": 92,
	"./mugs/mug-7/metadata.json": 93,
	"./mugs/mug-8/metadata.json": 94,
	"./mugs/mug-9/metadata.json": 95,
	"./pitchers/pitcher-1/metadata.json": 96,
	"./plates/plate-1/metadata.json": 97,
	"./vases/metadata.json": 98,
	"./vases/vase-1/metadata.json": 99,
	"./vases/vase-2/metadata.json": 100,
	"./vases/vase-3/metadata.json": 101,
	"./vases/vase-4/metadata.json": 102,
	"./vases/vase-5/metadata.json": 103,
	"./vases/vase-6/metadata.json": 104,
	"./vases/vase-7/metadata.json": 105,
	"./vases/vase-8/metadata.json": 106,
	"./vases/vase-9/metadata.json": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;